import axios from 'axios';

// Create axios instance with relative base URL (nginx will proxy to backend)
const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// API service functions
export const currencyService = {
  // Health check
  async checkHealth() {
    const response = await api.get('/health');
    return response.data;
  },

  // Get all supported currencies
  async getCurrencies() {
    const response = await api.get('/currencies');
    return response.data;
  },

  // Get exchange rates for a specific base currency
  async getExchangeRates(baseCurrency = 'USD') {
    const response = await api.get(`/rates/${baseCurrency}`);
    return response.data;
  },

  // Convert currency
  async convertCurrency(amount, fromCurrency, toCurrency) {
    const response = await api.post('/convert', {
      amount,
      fromCurrency,
      toCurrency,
    });
    return response.data;
  },

  // Get historical data
  async getHistoricalData(fromCurrency, toCurrency, days = 30) {
    const response = await api.get(`/historical/${fromCurrency}/${toCurrency}?days=${days}`);
    return response.data;
  },

  // Get popular currency pairs
  async getPopularPairs() {
    const response = await api.get('/popular-pairs');
    return response.data;
  },
};

// Popular currencies data
export const popularCurrencies = [
  { code: 'USD', name: 'US Dollar', symbol: '$', flag: '🇺🇸' },
  { code: 'EUR', name: 'Euro', symbol: '€', flag: '🇪🇺' },
  { code: 'GBP', name: 'British Pound', symbol: '£', flag: '🇬🇧' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥', flag: '🇯🇵' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', flag: '🇨🇦' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', flag: '🇦🇺' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF', flag: '🇨🇭' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', flag: '🇨🇳' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹', flag: '🇮🇳' },
  { code: 'KRW', name: 'South Korean Won', symbol: '₩', flag: '🇰🇷' },
];

// Currency formatting utility
export const formatCurrency = (amount, currencyCode) => {
  const currency = popularCurrencies.find(c => c.code === currencyCode);
  const symbol = currency?.symbol || currencyCode;

  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount) + ' ' + symbol;
};

export default api;
